<template>
  <div id="header-area" class="header-area">
    <div class="container">
      <div class="row">
        <div class="col-6 text-start">
          <div>
            <router-link :to="'/home'" class="navbar-brand">
              <img src="/assets/img/empty.png" class="logo" alt="Logo">
            </router-link>
          </div>
        </div>

        <div class="col-6 text-end">
          <div class="language">
            <a
                class="navbar-brand"
                v-if="$i18n.locale == 'ar'"
                href="javascript:;"
                @click="change('en')"
                style="color: #fff;">
              English
            </a>
            <a
                class="navbar-brand"
                v-if="$i18n.locale == 'en'"
                href="javascript:;"
                @click="change('ar')"
                style="color: #fff;">
              العربية
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderTop',
  components: {},
  data() {
    return {
      socials: [],
      settings: {
        email: "",
        phone: "",
      },
      pgLoading: false,
    }
  },
  created() {
    if (localStorage.getItem('settings.email')) {
      this.settings.email = localStorage.getItem('settings.email');
    }
    if (localStorage.getItem('settings.phone')) {
      this.settings.phone = localStorage.getItem('settings.phone');
    }

    if (localStorage.getItem('locale') != 'ar') {
      this.switchLang('en');
    } else {
      this.switchLang('ar');
    }
  },
  mounted() {
    if (localStorage.getItem('locale') == 'ar') {
      // document.getElementById("header-area").classList.add('is-rtl');
    }
  },
  methods: {
    //
    switchLang: function (lang) {
      if (lang == 'ar') {
        localStorage.setItem('locale', 'ar');
      } else {
        localStorage.setItem('locale', 'en');
      }
    },
    //
    change: function (lang) {
      this.switchLang(lang);
      window.location.reload();
    },

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.language  {
  margin-left: 10px;
  margin-top: 15px;
}
</style>
